// extracted by mini-css-extract-plugin
export default {"home":"Psychedelics_home__fEwN9","services":"Psychedelics_services__2lZ8T"};